import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';
import { Grid, NavLink, Stack, Text, Title } from '@mantine/core';
import { IconUser, IconAdjustments, IconLock, IconDeviceMobile, IconShieldCheck } from '@tabler/icons-react';

export const Route = createFileRoute('/_app/settings')({ component: SettingsLayout });

const items = [
  { to: '/settings', label: 'Panoramica', icon: IconAdjustments, end: true },
  { to: '/settings/profile', label: 'Profilo', icon: IconUser },
  { to: '/settings/preferences', label: 'Preferenze', icon: IconAdjustments },
  { to: '/settings/security', label: 'Sicurezza', icon: IconLock },
  { to: '/settings/devices', label: 'Dispositivi', icon: IconDeviceMobile },
  { to: '/settings/privacy', label: 'Privacy / GDPR', icon: IconShieldCheck },
];

function SettingsLayout() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  return (
    <Stack>
      <Title order={1}>Impostazioni</Title>
      <Grid>
        <Grid.Col span={{ base: 12, sm: 3 }}>
          <Stack gap={4}>
            {items.map((it) => {
              const active = it.end ? path === it.to : path.startsWith(it.to);
              return (
                <NavLink
                  key={it.to}
                  component={Link}
                  to={it.to}
                  active={active}
                  label={it.label}
                  leftSection={<it.icon size={18} />}
                />
              );
            })}
            <Text size="xs" c="dimmed" mt="sm">
              Le impostazioni del tenant sono in <strong>Tenant</strong> (sidebar principale).
            </Text>
          </Stack>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 9 }}>
          <Outlet />
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
